import { MultiScreenBase } from './MultiScreenBase';

export class MultiScreenReceiver extends MultiScreenBase {
    readonly receiver: PresentationReceiver;


    constructor(receiver: PresentationReceiver) {
        super();

        this.receiver = receiver;

        this._startConnectionListMonitor(); // intentionally non-awaited
    }

    private async _startConnectionListMonitor() {
        try {
            const connectionList = await this.receiver.connectionList;

            connectionList.connections.forEach(connection => {
                this.setupSession(connection);
            });

            connectionList.onconnectionavailable = event => {
                const connection = event.connection;
                this.setupSession(connection);
            };
        } catch (e) {
            this._onError(e);
        }
    }
}
